import React from 'react';
import { useResumePrintEventScan } from '../../hooks/useResumePrintEventScan';
import type { PrintOrderSource } from '@/shared/types/printOrder.types';
import type { DestinationPrinterId } from '@/shared/types/printer.types';
import PrintEventHandlingModal from './PrintEventHandlingModal';

interface PrintEventScanResumeHostProps {
  readonly source: PrintOrderSource;
  readonly printerId: DestinationPrinterId;
}

/** Reopens Print Event Handling on pages that unmount PrintBoxLabel during Scan Label. */
function PrintEventScanResumeHost({
  source,
  printerId,
}: PrintEventScanResumeHostProps): React.ReactElement | null {
  const resume = useResumePrintEventScan();
  if (!resume.job) return null;

  return (
    <PrintEventHandlingModal
      key={`${resume.job.order.id}:${resume.scannedPrefix ?? ''}`}
      isOpen
      onClose={resume.clear}
      job={resume.job}
      source={source}
      printerId={printerId}
      initialScannedPrefix={resume.scannedPrefix}
    />
  );
}

export default PrintEventScanResumeHost;
